import React, { useEffect, useState } from "react";
import SocialMedia from "./SocialMedia";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";
import * as MonitorType from "../../../../store/monitorService/types";
import * as MonitorActions from "../../../../store/monitorService/actions";
import { ISocialMediaResponse } from "../../../../store/socialMediaMonitoringService/types";
import * as SocialMediaActions from "../../../../store/socialMediaMonitoringService/actions";
import * as httpClient from "../../../../util/httpClient";
import { Notification } from "../../../common/Notification";
import * as NextStepFlowAction from "../../../../store/nextStepFlowService/actions";
import { flowName, getFlowByName } from "../../../../config/FlowName";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
interface IProps {}

const SocialMediaMonitoring: React.FunctionComponent<IProps> = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const defaultSocialMonitorInfo: MonitorType.IMonitorResponse = {
        id: "0",
        name: "",
        "resource-name": "",
        detail: "",
        active: false,
        category: "",
        type: "",
        personalInfo: "",
        "order-num": "",
        maxType: "",
        nickname: "",
        "account-information": "",
        message: "",
        "fastlink-url": "",
    };
    const { t: tLang } = useTranslation();
    const dispatch = useDispatch();
    const requestMonitors = (forcerfullyLoaded: boolean) => dispatch(MonitorActions.actionCreators.requestMonitors(forcerfullyLoaded));
    const requestSocialMedia = (socialMediaResponse: ISocialMediaResponse) => dispatch(SocialMediaActions.actionCreators.requestCallback(socialMediaResponse));
    const socialDetailQuery = new URLSearchParams(window.location.search);
    let network = socialDetailQuery.get("network")!;
    const socialMediaMonitors = useSelector((state: ApplicationState) => {
        let facebook, twitter, instagram, youtube, isLoading;
        if (state.monitorData != null && state.monitorData.monitorData != null) {
            facebook = state.monitorData.monitorData.find(
                (monitor) => monitor["resource-name"] === "SocialMediaMonitoring" && monitor.category === "Social" && monitor.detail === "facebook"
            );
            twitter = state.monitorData.monitorData.find(
                (monitor) => monitor["resource-name"] === "SocialMediaMonitoring" && monitor.category === "Social" && monitor.detail === "twitter"
            );
            instagram = state.monitorData.monitorData.find(
                (monitor) => monitor["resource-name"] === "SocialMediaMonitoring" && monitor.category === "Social" && monitor.detail === "instagram"
            );
            youtube = state.monitorData.monitorData.find(
                (monitor) => monitor["resource-name"] === "SocialMediaMonitoring" && monitor.category === "Social" && monitor.detail === "youtube"
            );
            isLoading = state.monitorData.isLoading;
        }
        return {
            facebook: facebook ? facebook : defaultSocialMonitorInfo,
            twitter: twitter ? twitter : defaultSocialMonitorInfo,
            instagram: instagram ? instagram : defaultSocialMonitorInfo,
            youtube: youtube ? youtube : defaultSocialMonitorInfo,
            isLoading: isLoading ? isLoading : false,
        };
    });

    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );

    const removeNextStep = (flowName: string) => dispatch(NextStepFlowAction.actionCreators.removeNextStep(flowName));
    const socialMediaCallbackSelector = useSelector((state: ApplicationState) => {
        return state.socialMediaState?.callbackData;
    });
    const socialMediaFlow = useSelector((state: ApplicationState) => getFlowByName(state, "ADD-YOUR-SOCIAL-MEDIA-ACCOUNTS"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const focus = query.get("focus");
        if (focus) {
            var element = document.querySelector("#" + focus);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }
    }, [socialMediaMonitors]);

    const ensureDataFetched = () => {
        if (renderSiteInIFrame) {
            requestMonitors(true);
        } else {
            requestMonitors(false);
        }
    };

    const socialMediaNextStep = useSelector((state: ApplicationState) => {
        if (state.nextStepFlowState && state.nextStepFlowState.flows) {
            return state.nextStepFlowState.flows.find((element) => element["flowName"] === flowName.dashboardReconnectSocialMedia);
        } else {
            return null;
        }
    });

    useEffect(() => {
        if (renderSiteInIFrame) {
            const handleMessage = (event: any) => {
                if (event.origin !== window.location.origin) {
                    return;
                }
                const receivedData = event.data;
                if (receivedData && receivedData.network) {
                    updatedSocialMedia(receivedData);
                    requestSocialMedia({} as ISocialMediaResponse);
                }
            };
            window.addEventListener("message", handleMessage);
            return () => {
                window.removeEventListener("message", handleMessage);
            };
        }
    }, []);

    useEffect(() => {
        if ((socialMediaCallbackSelector != null && socialMediaCallbackSelector.network != null) || (network && !isUpdate)) {
            updatedSocialMedia(socialMediaCallbackSelector);
            requestSocialMedia({} as ISocialMediaResponse);
        }
    }, [socialMediaCallbackSelector]);

    useEffect(ensureDataFetched, []);

    const updatedSocialMedia = (socialMediaAuthResponse?: ISocialMediaResponse) => {
        let networkId = 0;
        let requestBody = {};
        if (socialMediaAuthResponse) {
            if (socialMediaAuthResponse.network === "facebook") {
                networkId = 1;
            } else if (socialMediaAuthResponse.network === "twitter") {
                networkId = 2;
            } else if (socialMediaAuthResponse.network === "instagram") {
                networkId = 4;
            } else if (socialMediaAuthResponse.network === "youtube") {
                networkId = 6;
            }

            requestBody = {
                "network-id": networkId.toString(),
                "social-network-account-number": socialMediaAuthResponse.account_number ? socialMediaAuthResponse.account_number : "",
                "social-network-account-url": "",
                "social-network-refresh-token": socialMediaAuthResponse.refresh_token ? socialMediaAuthResponse.refresh_token : "",
                "social-network-secret": socialMediaAuthResponse.secret ? socialMediaAuthResponse.secret : "",
                "social-network-token": socialMediaAuthResponse.token ? socialMediaAuthResponse.token : "",
                "social-network-token-expiration": socialMediaAuthResponse.token_expiration ? socialMediaAuthResponse.token_expiration : "",
            };
        }

        if (network) {
            let account_number = socialDetailQuery.get("account_number")!;
            let token = socialDetailQuery.get("token")!;
            let refresh_token = socialDetailQuery.get("refresh_token")!;
            let token_expiration = socialDetailQuery.get("token_expiration")!;
            let secret = socialDetailQuery.get("secret")!;
            if (network === "facebook") {
                networkId = 1;
            } else if (network === "twitter") {
                networkId = 2;
            } else if (network === "instagram") {
                networkId = 4;
            } else if (network === "youtube") {
                networkId = 6;
            }

            requestBody = {
                "network-id": networkId.toString(),
                "social-network-account-number": account_number || "",
                "social-network-account-url": "",
                "social-network-refresh-token": refresh_token || "",
                "social-network-secret": secret || "",
                "social-network-token": token || "",
                "social-network-token-expiration": token_expiration || "",
            };
        }
        const hideSociaMediaNextStep = () => {
            if (socialMediaNextStep) {
                removeNextStep(flowName.dashboardReconnectSocialMedia);
            }
            if (socialMediaFlow && socialMediaFlow.flowStepStatus !== "COMPLETED") {
                completeGetStartedItem(socialMediaFlow.flowStepId, socialMediaFlow.flowName ? socialMediaFlow.flowName : " ");
            }
        };

        setIsLoading(true);

        httpClient
            .sendRequest("PUT", `api/zeroFOX/updateSocialMedia`, requestBody)
            .then((data) => {
                setIsLoading(false);
                hideSociaMediaNextStep();
                requestMonitors(true);
                Notification({
                    type: "success",
                    title: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.addSuccess.title"),
                    message: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.addSuccess.message"),
                });
                if (network) {
                    window.close();
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.addError.title"),
                    message: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.addError.message"),
                    duration: 0,
                });
            });
        setIsUpdate(true);
    };

    return (
        <div className={`box offset-padding ${(isLoading || socialMediaMonitors.isLoading) && "loading"}`} id="social-media-accounts">
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <RenderIcons iconName="users" />
                    </div>
                    <div className="box-title-text">
                        <h2 className="box-title">{tLang("identityVault.monitoredInformation.socialMediaWidget.title")}</h2>
                    </div>
                </div>
                <div className="box-description">
                    <p>{tLang("identityVault.monitoredInformation.socialMediaWidget.message")}</p>
                </div>
            </div>
            <div id="socialMedia" className="box-content">
                <div role="grid" className="data-grid has-lines row-height-md margin-top-l">
                    <SocialMedia
                        networkId={1}
                        addLinkText={tLang("identityVault.monitoredInformation.socialMediaWidget.addAccountButtonText.facebook")}
                        socialMediaId={socialMediaMonitors.facebook.id}
                        socialMediaName="Facebook"
                        accountInformation={socialMediaMonitors.facebook["account-information"]}
                        active={socialMediaMonitors.facebook.active}
                    />
                    <SocialMedia
                        networkId={2}
                        addLinkText={tLang("identityVault.monitoredInformation.socialMediaWidget.addAccountButtonText.twitter")}
                        socialMediaId={socialMediaMonitors.twitter.id}
                        socialMediaName="Twitter"
                        accountInformation={socialMediaMonitors.twitter["account-information"]}
                        active={socialMediaMonitors.twitter.active}
                    />
                    <SocialMedia
                        networkId={4}
                        addLinkText={tLang("identityVault.monitoredInformation.socialMediaWidget.addAccountButtonText.instagram")}
                        socialMediaId={socialMediaMonitors.instagram.id}
                        socialMediaName="Instagram"
                        accountInformation={socialMediaMonitors.instagram["account-information"]}
                        active={socialMediaMonitors.instagram.active}
                    />
                    <SocialMedia
                        networkId={6}
                        addLinkText={tLang("identityVault.monitoredInformation.socialMediaWidget.addAccountButtonText.youtube")}
                        socialMediaId={socialMediaMonitors.youtube.id}
                        socialMediaName="YouTube"
                        accountInformation={socialMediaMonitors.youtube["account-information"]}
                        active={socialMediaMonitors.youtube.active}
                    />
                </div>
            </div>
        </div>
    );
};

export default SocialMediaMonitoring;
